import { useActions } from 'shared/hooks';
import { putContactInfo, postConsultation, postCustomBlock } from 'store/survey/actions';
import { SendContactData } from '../../../../api/surveys/types';
import * as React from 'react';

export const useSurveyActions = () =>
  useActions({
    putContactInfo,
    postConsultation,
    postCustomBlock,
  });

export const useHandleSubmit = () => {
  const { putContactInfo: postAction, postConsultation: finalizeConsultation } = useSurveyActions();
  return async (
    data: SendContactData,
    showError: React.Dispatch<React.SetStateAction<boolean>>,
    finishedPosting: React.Dispatch<React.SetStateAction<boolean>>,
  ) => {
    try {
      await postAction(data);
      finishedPosting(true);
    } catch (e) {
      showError(true);
    }
  };
};

export const useFinalizeConsultation = () => {
  const { postConsultation: finalizeConsultation } = useSurveyActions();
  return async (id: string) => {
    try {
      await finalizeConsultation({ respondent_id: id });
    } catch (e) {
      console.log(e);
    }
  };
};

export const useFinalizeCustomBlock = () => {
  const { postCustomBlock: finalizeCustomBlock } = useSurveyActions();
  return async (url: string, did_opt_in: boolean) => {
    try {
      await finalizeCustomBlock({ survey_request_url: url, did_opt_in });
    } catch (e) {
      console.log(e);
    }
  };
};
